<template>
	<div class="mobile">
		<h1>Olá,</h1>
		<p>
			Este simulado não está disponível para dispositivos móveis.
		</p>
		<p>
			Para obter a melhor experiência com o simulado do CNA, por favor, utilize um <strong>notebook</strong> ou <strong>desktop</strong>.
		</p>
	</div>
</template>

<script>
	export default {

	}
</script>


// WEBPACK FOOTER //
// src/components/start/Mobile.vue